
import React, { useEffect } from 'react';
import { Button } from "@/components/ui/button";
import { Navbar } from "@/components/blocks/Navbar";
import { Footer } from "@/components/blocks/footer";
import { RevealOnScroll } from "@/components/ui/reveal-on-scroll";
import { Seo } from "@/components/Seo";


const Privacy = () => {
  // Add useEffect to scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const footerData = {
    logo: <img src="/lovable-uploads/c22d7cd3-d7b2-4b69-9087-2e231ebb8feb.png" alt="Quickatoo Logo" className="h-10 w-auto" />,
    brandName: "Quickatoo",
    socialLinks: [],
    mainLinks: [{
      href: "/",
      label: "Home"
    }],
    legalLinks: [{
      href: "/privacy",
      label: "Privacy"
    }, {
      href: "/terms",
      label: "Terms"
    }],
    copyright: {
      text: "© 2024 Quickatoo",
      license: "All rights reserved"
    }
  };

  return <>
      <Seo
        title="Privacy Policy — Quickatoo"
        description="How Quickatoo collects, uses and protects the personal information of painting contractors using our quoting and job management software."
        path="/privacy"
      />
      <Navbar />

      <main className="pt-28 pb-16 px-4 max-w-4xl mx-auto min-h-screen">
        <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
        
        <div className="space-y-6">
          <RevealOnScroll>
            <section>
              <h2 className="text-2xl font-semibold mb-4">Introduction</h2>
              <p className="text-gray-700 dark:text-gray-300">
                At Quickatoo, we respect your privacy and are committed to protecting your personal data. This privacy policy will inform you about how we look after your personal data when you visit our website and use our services.
              </p>
            </section>
          </RevealOnScroll>

          <RevealOnScroll delay={100}>
            <section>
              <h2 className="text-2xl font-semibold mb-4">The Data We Collect</h2>
              <p className="text-gray-700 dark:text-gray-300">
                We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:
              </p>
              <ul className="list-disc pl-5 mt-2 space-y-1 text-gray-700 dark:text-gray-300">
                <li>Identity Data: includes first name, last name, username or similar identifier</li>
                <li>Contact Data: includes email address and telephone numbers</li>
                <li>Technical Data: includes internet protocol (IP) address, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform</li>
                <li>Usage Data: includes information about how you use our website and services</li>
              </ul>
            </section>
          </RevealOnScroll>

          <RevealOnScroll delay={200}>
            <section>
              <h2 className="text-2xl font-semibold mb-4">How We Use Your Data</h2>
              <p className="text-gray-700 dark:text-gray-300">
                We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
              </p>
              <ul className="list-disc pl-5 mt-2 space-y-1 text-gray-700 dark:text-gray-300">
                <li>To register you as a new customer</li>
                <li>To process and deliver your service requests</li>
                <li>To manage our relationship with you</li>
                <li>To improve our website, products/services, marketing or customer relationships</li>
                <li>To recommend products or services that may be of interest to you</li>
              </ul>
            </section>
          </RevealOnScroll>

          <RevealOnScroll delay={300}>
            <section>
              <h2 className="text-2xl font-semibold mb-4">Data Security</h2>
              <p className="text-gray-700 dark:text-gray-300">
                We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know.
              </p>
            </section>
          </RevealOnScroll>

          <RevealOnScroll delay={400}>
            <section>
              <h2 className="text-2xl font-semibold mb-4">Data Retention</h2>
              <p className="text-gray-700 dark:text-gray-300">
                We will only retain your personal data for as long as necessary to fulfill the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements.
              </p>
            </section>
          </RevealOnScroll>

          <RevealOnScroll delay={500}>
            <section>
              <h2 className="text-2xl font-semibold mb-4">Your Legal Rights</h2>
              <p className="text-gray-700 dark:text-gray-300">
                Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to request access, correction, erasure, restriction, transfer, to object to processing, to portability of data and (where the lawful ground of processing is consent) to withdraw consent.
              </p>
            </section>
          </RevealOnScroll>

          <RevealOnScroll delay={600}>
            <section>
              <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
              <p className="text-gray-700 dark:text-gray-300">
                If you have any questions about this privacy policy or our privacy practices, please contact us at <a href="mailto:info@quickatoo.com" className="text-primary hover:underline">info@quickatoo.com</a>.
              </p>
            </section>
          </RevealOnScroll>
        </div>

        <RevealOnScroll delay={700}>
          <Button className="mt-10" asChild>
            <a href="/">Back to Home</a>
          </Button>
        </RevealOnScroll>
      </main>
      <Footer {...footerData} />
    </>;
};

export default Privacy;
